const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  uid: state => state.user.uid,
  role: state => state.user.role,
  user_company: state => state.user.user_company,
  user_project: state => state.user.user_project,
  company_name: state => state.user.company_name,
  company_uid: state => state.user.company_uid,
  user_compliancework: state => state.user.user_compliancework,
  flag_flowfund: state => state.user.flag_flowfund,
  flag_firewallsetting: state => state.user.flag_firewallsetting,
  is_whitelabel: state => state.user.is_whitelabel
};
export default getters;
